let flippedCards = 0;

// giftImages = [
//   "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Cleaner_Cloth_Single.png?v=1786581172",
//   "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Dishwashing_Machine_Cleaner_2_Pack_-_Single.png?v=1786581172",
//   "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Scrub_Sponge_-_Single.png?v=1786581172",
//   "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Dish_Soap_Strips_single_-_60_Pack_2_-_Single.png?v=1786581171",
// ];

productImages = [
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_1.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_2.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_3.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_4.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_5.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_6.png",
  "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/Confetti_7.png",
]

document.body.classList.add("scroll-lock");

// const spinningWheelVideo = document.querySelector('.game-grid video');
const spinningWheelImage = document.querySelector('.game-grid img');
const playButton = document.querySelector('.play-button');
const completeButton = document.querySelector('.complete-button');

playButton.addEventListener('click', () => {
    // spinningWheelVideo.play();
    spinningWheelImage.src = "https://cdn.shopify.com/s/files/1/0596/6377/7980/files/SpinToWin_NoLoop.gif?v=1789000347"
    playButton.classList.add('pulse-button')
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('spin_ended'));
    }, 2650)
});

document.addEventListener('spin_ended', (event) => {
  document.querySelector('.progress-container').classList.add('complete')
    playButton.classList.remove('pulse-button')
    completeButton.classList.add('pulse-buzz');
    // playButton.textContent = `You've won 52% Off! 🎉`;
    createConfetti(productImages);
});

function closePopup() {
  document.body.classList.remove("scroll-lock");
  document.querySelector(".game-container").remove();
}

playButton.addEventListener("click", () => {
  if(playButton.classList.contains('pulse-buzz')){
    closePopup();
    gtag("event", "game_complete", {
      game_name: "spin_to_win",
    });
  }
});

document.querySelector(".icon-close").addEventListener("click", () => {
  // closePopup();
  gtag("event", "game_close", {
    game_name: "spin_to_win",
    close_method: "icon",
  });
});

document.querySelector(".close-link").addEventListener("click", () => {
  // closePopup();
  gtag("event", "game_close", {
    game_name: "spin_to_win",
    close_method: "close-text",
  });
});